import templateUrl from "emun.order/backorders/backorders-list.htm";
import controller from "emun.order/backorders/backorders-list.controller";

export default {
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
